import { render, staticRenderFns } from "./juniorInnovation.vue?vue&type=template&id=1c85c5c4&"
import script from "./juniorInnovation.vue?vue&type=script&lang=js&"
export * from "./juniorInnovation.vue?vue&type=script&lang=js&"
import style0 from "./juniorInnovation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports